import React from 'react';

const DataContext = React.createContext({
	id: null,
	active: false,
});

export default DataContext;
